import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConnectionStatus, Network } from '@capacitor/network';

@Injectable({
  providedIn: 'root',
})
export class ConnectionService {
  readonly state$ = new BehaviorSubject<ConnectionStatus | null>(null);
  readonly freeze$ = new BehaviorSubject<boolean>(false);

  constructor() {
    Network.addListener('networkStatusChange', (state) => {
      const currentState = this.state$.value;
      if (state.connected !== currentState?.connected || state.connectionType !== currentState?.connectionType) {
        if (this.freeze$.value === false) {
          this.state$.next(state);
        }
      }
    });
    this.getStatus().then((status) => this.state$.next(status));
  }

  readonly getStatus = Network.getStatus.bind(this);
}
